<template>
  <tr>
    <td>
      <img style="max-height: 50px; max-width: 75px;" :src="carImage"/>
      <br/>
      <router-link :to="`/fleet/vehicles/${petrolCard.Car.uuid}`">
        {{ petrolCard.Car.dropdownLabel }}
      </router-link>
    </td>
    <td>
      {{ petrolCard.name }}
    </td>
    <td>
      {{ petrolCard.number }}
    </td>
    <td>
      {{ petrolCard.pin }}
    </td>
    <td>
      {{ petrolCard.provider }}<br/>
      {{ petrolCard.providerPhone }}
    </td>
    <td>
      {{ petrolCard.providerEmail }}
    </td>
    <td>
      <router-link class="btn btn-sm btn-primary" :to="'/hardware/petrol-cards/edit/' + petrolCard.uuid">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
    </td>
  </tr>
</template>

<script>

export default {
  components: {
  },
  name: 'PetrolCardRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    carImage () {
      return 'https://techcar-dev.s3.amazonaws.com/' +
      this.petrolCard.Car.CarType.AmazonImage.objectKey
    },
    petrolCard () {
      return {
        Car: {
          CarType: {
            AmazonImage: {
              objectKey: 'spacer.gif'
            }
          }
        },
        ...this.object,
        ...this.updatedPetrolCard
      }
    }
  },
  data () {
    return {
      updatedPetrolCard: {}
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/PetrolCard.vue